var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowRightDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 52,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    d: "M0 0h57v52H0z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "a",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b",
    transform: "scale(.01754 .01923)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "b",
    width: 57,
    height: 52,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADkAAAA0CAYAAAAwhpBbAAAEbklEQVRogdWaX6gVRRzHP/daqVniPWVJRZBgFNH/m92iAh8Keg0MqodAwhAjqoegwoogSvBNEKqHIirCXqTHggwK7tGignqIDCLiimGZxb1YWRY/+S6MM7N7Zndn9x4/cDjXnT/u98z8Zr6/2Z2Ym5sjA8uBl4Engb9ydJiTyUx9HQM2A58Ca4PSRSaXSOMIMA18CWwMSheRnCJ/0fdKYDewC1gW1FoEcor81fv3FmAWWBfU7Jnc09XnOuAL4IGgpEe6FmmcA7wFvAacHZT2QBcxWcZDwPMlZZ3SZUzGuCBy7bQSWTZdXc4LrvRA3yLPD670EKd9xqQxCK7AS3JLndF3TMZEmiV8BXhbRiI7fU9XEznhXStmwP3A59pbs9K3yMnIaLrt1sklPRK0bEFOkf8AvwdXQ6pEIr+7U/53VdC6ATlF0jAuy9pslCWcDkpqkltkk72yalW+TDnqY0FJDRZDpL9XjmqzFNgRXK1BTpGDxP786fpbUCNkSaRdMme0aHctcDMwo+/Lg1px/Jv9G5hXtlLFwBl1+zH/0yfpZlO4WEJu0fe0Dq+aEPOvhxNFFpi494FNaltJTKTd/I3OKNnnkqBWc2L+9YgWmSp8kTM6T7oP+KSi3UmRNs3WO4KuAc4MauYjFlspC9bqSBu794+AF4AXgRNBK4m8SYdO5wal4yWyzESYBhN5G/AgcMhvOCljbNPzq6DbbpiK9DoyripEFtyl6bshJtI4oEVlV9B1fmKZRpORjJmINcCHmr5LfJHGn8BW4F7gj6B5c34E3gUeB27VSt1EZCwmY5i4bRJ7ESWr63tKeXY38I3zajvUZ18sRiKU3bDLqOnqs0EHZ5tjIo0fFMjbgUcjOSBaxr+VkFl9fwP8G9QcTUpM+rFcZuxdTv4wZSLR0ykzxh8Dr2t5LkZnn/5OSa2qWAHcANxdUacgJSajbapEFuzR/F4ISuoxoX1tRvuyLXRX13BddY09hbtK/Q+aCFzlCVofGY06rJRJOa42yRlPU4PuY/1cJTGFsCtKYrkN9iP9rPYpMTnVVuSVchgzWoVXBDXy44pMiUnz4cvbiDygFfb2DpLvMty4XNDiaEl1FYM2N2cHV09pZUzZAnLgp2lJJiLHCHygs9K9QUk+TmgP9reslFOFQa6F5yBwJ/As8IzrGxtiM2O/45w+iwgk1djnEomcznMyD+/ILKdwXBnQ0BH2fWLbJDuYU2TBXk3fN5X++PzkOKdZpUfHglrVFFtW7CjFZ3UXItEybwvS0xI6lCAbqSZvR61xzpfqblmDXG9k5WSpkvjiSMbEXdqi/ze6Gsk6rPWONq8HzsrYfycxOQpL4e6QIPtcOKJ+WzqLySrMRDzccgrWYaovO+YyVA65Jyjphla2rg2WQdwDPNHDq6Pz47C6Tus8adQJegoLeqY5dI5kDo7LFmIJ9qs1XyG1DOg7xymZqK8V86cwbvvkVj2LjL1CetQTtD/R1o2dSMMsoXlfe6RnYgphdjKY9KjuFID/AW/d6LVKB2JxAAAAAElFTkSuQmCC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRightDown);
export default __webpack_public_path__ + "static/media/arrow_right_down.6aec1552e0f3bd121e0d18e35c0d0402.svg";
export { ForwardRef as ReactComponent };